import React, {useMemo, useState, useEffect} from "react";
import {useLocation} from "react-router-dom";

import Header from "shared/components/Header/Header";
import {SelectOptionsPanel} from "shared/components/inputFields";
import ILanguagePackage, {Paragraph, Image} from "../ILanguagePackage";
import Belarusian from "../static/Belarusian";
import Ukrainian from "../static/Ukrainian";
import English from "../static/English";

const UserManualPage = () => {
    const [selectedLanguageIdx, setSelectedLanguageIdx] = useState(0);
    const availableLanguages: ILanguagePackage[] = useMemo(() => [English, Ukrainian, Belarusian], []);
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth"});
            }
        }
    }, [location]);

    return (
        <div className="home-page">
            <Header logOut={false} help={false}/>
            <div className="main-area">
                <div className="cat-list-sidebar">
                    <div className="category-list">
                        <h3>{availableLanguages[selectedLanguageIdx].additional.tableOfContents}</h3>
                        <div className="scrollable categories-container-wrapper">
                            <div id="categories-container">{
                                availableLanguages[selectedLanguageIdx].content.map(section =>
                                    <div
                                        className={'category-container category-container-inactive'}
                                        onClick={() => {window.location.hash = `${section.id}`}}>
                                        <p className="cat-name">{section.heading}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main">
                    <div style={{width: 170 * availableLanguages.length}}><SelectOptionsPanel
                        options={availableLanguages.map(l => l.name)} selectedIdx={selectedLanguageIdx}
                        setSelectedIdx={setSelectedLanguageIdx}/></div>

                    <div className="scrollable logs-container">
                        {availableLanguages[selectedLanguageIdx].content.map(section => <div id={section.id}>
                            <h2 className='manual-section-header'>{section.heading}</h2>
                            {section.content.map(p => <ParagraphComponent p={p} picture={availableLanguages[selectedLanguageIdx].additional.picture}/>)}
                        </div>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ParagraphComponent = ({p: {content, links, type}, picture}: { p: Paragraph, picture: string }) => {
    if (type === "image")
        return (
            <div className="manual-image-wrapper">
                <img className='manual-image'
                     src={(content as Image).src}
                     alt={(content as Image).description}
                     id={`img-${(content as Image).imgId}`}/>
                <p className='manual-image-description'>{picture} {(content as Image).imgId} - {(content as Image).description}</p>
            </div>
        );

    if (links === undefined || links.length === 0)
        return type === "text"? (
            <p className="manual-paragraph">{content as string}</p>
        ) : type === "u-list"? (
            <ul>
                {(content as string[]).map(li => <li className="manual-li">{li}</li>)}
            </ul>
        ) : type === "o-list"? (
            <ol>
                {(content as string[]).map(li => <li className="manual-li">{li}</li>)}
            </ol>
        ) : (<></>);

    if (type === "text") {
        const contents = (content as string).split('[[lnk]]');
        const pairs_num = Math.min(contents.length-1, (links)!.length);

        return (
            <p className="manual-paragraph">{
                Array.from({ length: pairs_num }, (_, x) => <>{contents[x]}<a href={(links)![x].href} target="_blank" rel="noreferrer" style={{color: "yellow"}}>{(links)![x].title}</a></>)
            }{
                contents.slice(pairs_num).join('')
            }</p>
        );
    } else {
        let processedLinks = 0;
        return type === 'u-list'? (
            <ul>
                {(content as string[]).map(li => {
                    const contents = li.split('[[lnk]]');
                    const pairs_num = Math.min(contents.length - 1, (links)!.length-processedLinks);
                    return (
                        <li className="manual-li">{
                            Array.from({length: pairs_num}, (_, x) => { return (<>{contents[x]}<a href={(links)![processedLinks].href}
                                                                                        target="_blank" rel="noreferrer"
                                                                                        style={{color: "yellow"}}>{(links)![processedLinks++].title}</a></>);})
                        }{
                            contents.slice(pairs_num).join('')
                        }</li>
                    );
                })}
            </ul>
        ) : type === 'o-list'? (
            <ol>
                {(content as string[]).map(li => {
                    let processedLinks = 0;
                    const contents = li.split('[[lnk]]');
                    const pairs_num = Math.min(contents.length - 1, (links)!.length-processedLinks);
                    return (
                        <li className="manual-li">{
                            Array.from({length: pairs_num}, (_, x) => { return (<>{contents[x]}<a href={(links)![processedLinks].href}
                                                                                        target="_blank" rel="noreferrer"
                                                                                        style={{color: "yellow"}}>{(links)![processedLinks++].title}</a></>);})
                        }{
                            contents.slice(pairs_num).join('')
                        }</li>
                    );
                })}
            </ol>
        ) : (<></>);
    }
}

export default UserManualPage;